export default "__VITE_ASSET__Dhhtni1J__"